var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
import {
  WalletReadyState
} from "@aptos-labs/wallet-adapter-core";
import { Network } from "aptos";
var OKXWalletName = "OKX Wallet";
var OKXWallet = class {
  constructor() {
    this.name = OKXWalletName;
    this.url = "https://okx.com/web3/";
    this.icon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJDSURBVHgB7Zq9jtpAEMfHlhEgQLiioXEkoAGECwoKxMcTRHmC5E3IoyRPkPAEkI7unJYmTgEFTYwA8a3NTKScLnCHN6c9r1e3P2llWQy7M/s1Gv1twCP0ej37dDq9x+Zut1t3t9vZjDEHIiSRSPg4ZpDL5fxkMvn1cDh8m0wmfugfO53OoFQq/crn8wxfY9EymQyrVCqMfHvScZx1p9ls3pFxXBy/bKlUipGPrVbLuQqAfsCliq3zl0H84zwtjQrOw4Mt1W63P5LvBm2d+Xz+YzqdgkqUy+WgWCy+Mc/nc282m4FqLBYL+3g8fjDxenq72WxANZbLJeA13zDX67UDioL5ybXwafMYu64Ltn3bdDweQ5R97fd7GyhBQMipx4POeEDHIu2LfDdBIGGz+hJ9CQ1ABjoA2egAZPM6AgiCAEQhsi/C4jHyPA/6/f5NG3Ks2+3CYDC4aTccDrn6ojG54MnEvG00GoVmWLIRNZ7wTCwDHYBsdACy0QHIhiuRETxlICWpMMhGZHmqS8qH6JLyGegAZKMDkI0uKf8X4SWlaZo+Pp1bRrwlJU8ZKLIvUjKh0WiQ3sRUbNVq9c5Ebew7KEo2m/1p4jJ4qAmDaqDQBzj5XyiAT4VCQezJigAU+IDU+z8vJFnGWeC+bKQV/5VZ71FV6L7PA3gg3tXrdQ+DgLhC+75Wq3no69P3MC0NFQpx2lL04Ql9gHK1bRDjsSBIvScBnDTk1WrlGIZBorIDEYJj+rhdgnQ67VmWRe0zlplXl81vcyEt0rSoYDUAAAAASUVORK5CYII=";
    this.provider = typeof window !== "undefined" ? window == null ? void 0 : window.okxwallet : void 0;
    this.readyState = typeof window !== "undefined" ? (window == null ? void 0 : window.okxwallet) ? WalletReadyState.Installed : WalletReadyState.NotDetected : WalletReadyState.Unsupported;
  }
  deeplinkProvider(data) {
    var _a;
    const target = (data == null ? void 0 : data.url) || ((_a = window == null ? void 0 : window.location) == null ? void 0 : _a.href);
    const downloadLink = "https://www.okx.com/download?deeplink=";
    const appLink = "okx://wallet/dapp/url?dappUrl=";
    const deepLink = downloadLink + encodeURIComponent(appLink + encodeURIComponent(target));
    return deepLink;
  }
  connect() {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        const addressInfo = yield (_b = (_a = this.provider) == null ? void 0 : _a.aptos) == null ? void 0 : _b.connect();
        if (!addressInfo)
          throw `${OKXWalletName} Address Info Error`;
        return addressInfo;
      } catch (error) {
        throw error;
      }
    });
  }
  account() {
    return __async(this, null, function* () {
      var _a, _b;
      const response = yield (_b = (_a = this.provider) == null ? void 0 : _a.aptos) == null ? void 0 : _b.account();
      if (!response)
        throw `${OKXWalletName} Account Error`;
      return response;
    });
  }
  disconnect() {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        yield (_b = (_a = this.provider) == null ? void 0 : _a.aptos) == null ? void 0 : _b.disconnect();
      } catch (error) {
        throw error;
      }
    });
  }
  signAndSubmitTransaction(transaction, options) {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        const response = yield (_b = (_a = this.provider) == null ? void 0 : _a.aptos) == null ? void 0 : _b.signAndSubmitTransaction(
          transaction,
          options
        );
        if (!response) {
          throw new Error("No response");
        }
        return response;
      } catch (error) {
        throw new Error(`${JSON.stringify(error)}`);
      }
    });
  }
  signTransaction(transaction, options) {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        const response = yield (_b = (_a = this.provider) == null ? void 0 : _a.aptos) == null ? void 0 : _b.signTransaction(
          transaction,
          options
        );
        if (!response) {
          throw new Error("Failed to sign transaction");
        }
        return response;
      } catch (error) {
        throw error;
      }
    });
  }
  signMessage(message) {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        if (typeof message !== "object" || !message.nonce) {
          `${OKXWalletName} Invalid signMessage Payload`;
        }
        const response = yield (_b = (_a = this.provider) == null ? void 0 : _a.aptos) == null ? void 0 : _b.signMessage(message);
        if (response) {
          return response;
        } else {
          throw `${OKXWalletName} Sign Message failed`;
        }
      } catch (error) {
        const errMsg = error.message;
        throw errMsg;
      }
    });
  }
  onNetworkChange(callback) {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        const handleNetworkChange = (networkInfo) => __async(this, null, function* () {
          callback({
            name: networkInfo == null ? void 0 : networkInfo.name,
            chainId: networkInfo == null ? void 0 : networkInfo.chainId,
            api: void 0
          });
        });
        yield (_b = (_a = this.provider) == null ? void 0 : _a.aptos) == null ? void 0 : _b.onNetworkChange(handleNetworkChange);
      } catch (error) {
        const errMsg = error.message;
        throw errMsg;
      }
    });
  }
  onAccountChange(callback) {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        const handleAccountChange = (newAccount) => __async(this, null, function* () {
          if (newAccount == null ? void 0 : newAccount.publicKey) {
            callback(__spreadValues({}, newAccount));
          } else {
            const response = yield this.connect();
            callback(__spreadValues({}, response));
          }
        });
        yield (_b = (_a = this.provider) == null ? void 0 : _a.aptos) == null ? void 0 : _b.onAccountChange(handleAccountChange);
      } catch (error) {
        console.log(error);
        const errMsg = error.message;
        throw errMsg;
      }
    });
  }
  network() {
    return __async(this, null, function* () {
      return {
        name: Network.MAINNET,
        chainId: "1"
      };
    });
  }
};
export {
  OKXWallet,
  OKXWalletName
};
